module.exports = __webpack_public_path__ + "static/media/colicoli14.b7b72f19.webp";